import * as React from "react";
import { motion, useInView, useMotionValue, useTransform, animate } from "framer-motion";

const STATS = [
  { target: 50, suffix: "+", label: "Trung tâm sử dụng" },
  { target: 1247, suffix: "", label: "Học viên quản lý" },
  { target: 94, suffix: "%", label: "Tỷ lệ đi học" },
  { target: 18, suffix: "", label: "Lớp vận hành mỗi ngày" },
];

const EASE = [0.32, 0.72, 0, 1] as const;

function AnimatedNumber({ target }: { target: number }) {
  const ref = React.useRef<HTMLSpanElement>(null);
  const isInView = useInView(ref, { once: true });
  const count = useMotionValue(0);
  const rounded = useTransform(count, (v) => Math.round(v).toLocaleString("en-US"));

  React.useEffect(() => {
    if (isInView) {
      const controls = animate(count, target, { duration: 1.6, ease: "easeOut" });
      return () => controls.stop();
    }
  }, [isInView, count, target]);

  return <motion.span ref={ref}>{rounded}</motion.span>;
}

export function LandingStats() {
  return (
    <section className="py-20 border-y border-slate-100 dark:border-slate-800 bg-white dark:bg-slate-900">
      <div className="max-w-5xl mx-auto px-5 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1, duration: 0.6, ease: EASE }}
          >
            <div className="font-display text-4xl md:text-5xl font-bold text-slate-900 dark:text-white tabular-nums">
              <AnimatedNumber target={s.target} />
              {s.suffix}
            </div>
            <div className="text-sm text-slate-500 dark:text-slate-400 mt-2">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
